<template>
  <v-container
    fluid
    grid-list-lg
    fill-height
    id="home"
    class="py-2"
  >
    <v-layout column>
      <v-flex xs12>
        <v-card
          flat
          class="border-round"
        >
          <v-card-title>
            <div class="d-flex justify-space-between" style="width: 100%;">
              <span>{{ cellname ? cellname + ' Quality Documents' : 'Quality Documents' }}</span>
              <div class="d-flex align-center">
                <v-btn text color="primary" :to="{
                  name: 'cellwiseQualityDashboard',
                  query: { selectedcell: cellname, theme: $route.query.theme }
                }">
                  <v-icon left dark>mdi-keyboard-backspace</v-icon>
                  Back
                </v-btn>
              </div>
            </div>
          </v-card-title>
          <v-card-text id="home-container">
            <v-data-table
              :headers="headers"
              :items="sops"
              :items-per-page="10"
              class="elevation-1"
              :loading="loading"
            >
              <template #[`item.action`]="{ item }">
                <v-dialog
                  v-model="item.dialog"
                  max-width="600px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-eye-outline
                          </v-icon>
                        </template>
                        <span>Preview</span>
                      </v-tooltip>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">
                        {{ item.filename }}
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <img
                        :src="item.url"
                        alt="Quality Document"
                        height="auto"
                        width="100%"
                        class="sopimg"
                        ref="layout"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="item.dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                      @click="handleDelete(item._id)"
                    >
                      <v-icon>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'Preview',
  data() {
    return {
      headers: [
        {
          text: 'File Name', align: 'start', sortable: false, value: 'filename',
        },
        {
          text: 'File Type', align: 'start', sortable: false, value: 'extension',
        },
        {
          text: '', align: 'start', sortable: false, value: 'action',
        },
      ],
      sops: [],
      loading: false,
    };
  },
  computed: {
    cellname() {
      return this.$route.query.cellname;
    },
  },
  mounted() {
    this.fetchFileList();
  },
  methods: {
    ...mapActions('cellwiseQualityDashboard', ['getFeedbackImg', 'getFile', 'deleteFile']),
    ...mapMutations('helper', ['setAlert']),

    async fetchFileList() {
      this.loading = true;
      let query = '?query=widget=="Quality Feedback"';

      const cell = this.cellname;

      if (cell && cell !== 'undefined') {
        query += `%26%26cellname=="${cell}"`;
      }

      const data = await this.getFeedbackImg(query);

      const result = [];
      if (data) {
        await Promise.all(data.map(async (d) => {
          const url = await this.getFile(d.downloadlink);
          const obj = { ...d, url };
          result.push(obj);
        }));
      }
      this.sops = result;
      this.loading = false;
    },
    async handleDelete(id) {
      const res = await this.deleteFile(id);
      if (res) {
        this.setAlert({ show: true, type: 'success', message: 'DELETE_RECORD' });
      } else {
        this.setAlert({ show: true, type: 'error', message: 'ERROR_DELETE_RECORD' });
      }
      this.fetchFileList();
    },
  },
};
</script>

<style lang="scss" scoped>
.border-round {
  border-radius: 10px;
}
</style>
